/* eslint-disable */
import book_hold_inventory from "@/apollo/cruises/bookings/context/book_hold_inventory.gql";
import context_data from "@/apollo/cruises/bookings/context/context_data.gql";
import un_hold_inventory from "@/apollo/cruises/bookings/context/un_hold_inventory.gql";
import cancellation from "@/apollo/cruises/bookings/context/cancellation.gql";

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 05 Mar 2025 | 03:26PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  fetchContextData(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { cruise_inventory_booking_context }
      } = await this.$apolloClient.query({ query: context_data, variables: { payload } });
      resolve(cruise_inventory_booking_context);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 07 Mar 2025 | 12:12PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  un_hold(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { cruise_release_hold_inventory }
      } = await this.$apolloClient.mutate({ mutation: un_hold_inventory, variables: { payload } });
      resolve(cruise_release_hold_inventory);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 10 Jan 2024 | 10:52AM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  book(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { cruise_book_hold_inventory }
      } = await this.$apolloClient.mutate({ mutation: book_hold_inventory, variables: { payload } });
      resolve(cruise_book_hold_inventory);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Mar 2025 | 03:34PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  cancel(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { cruise_booking_cancellation }
      } = await this.$apolloClient.mutate({ mutation: cancellation, variables: { payload } });
      resolve(cruise_booking_cancellation);
    });
  }
};
